import React, { useCallback } from 'react';
import { Box, FormProvider, getValidationResolver, SubmitHandler, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

import { IRoleSetup, RoleLevel } from '../../role.types';

import BasicProperties from './BasicProperties/BasicProperties';

interface Props {
  title?: React.ReactNode;
  isModalMode?: boolean;
  isViewMode?: boolean;
  isLoading?: boolean;
  defaultValues?: IRoleSetup | null;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  onSubmit?: (value: IRoleSetup) => void;
}

const RoleSetupForm: React.FC<Props> = ({
  title,
  isViewMode,
  footer,
  children,
  isLoading = false,
  defaultValues,
  isModalMode,
  onSubmit,
}) => {
  const methods = useForm<IRoleSetup>({
    defaultValues: defaultValues || undefined,
    resolver: getValidationResolver({
      name: VALIDATORS.REQUIRED_STRING,
      copyRoleId: VALIDATORS.STRING.when('isCopyRole', {
        is: (val?: boolean) => {
          return val === true;
        },
        then: () => VALIDATORS.REQUIRED_STRING,
        otherwise: () => VALIDATORS.STRING,
      }),
      level: VALIDATORS.REQUIRED_STRING,
      organizationId: VALIDATORS.STRING.when('level', {
        is: (val?: RoleLevel) => {
          return val === RoleLevel.Partner;
        },
        then: () => VALIDATORS.REQUIRED_STRING,
        otherwise: () => VALIDATORS.STRING,
      }),
    }),
  });

  const handleSubmit: SubmitHandler<IRoleSetup> = useCallback(
    (data) => {
      if (onSubmit) {
        onSubmit(data);
      }
    },
    [onSubmit]
  );

  return (
    <Box direction="column">
      <Box align="center" justify="center">
        {title}
      </Box>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <Box direction="column">
            <Box round="moduleRound" background="module" pad="l">
              <BasicProperties
                defaultValues={{
                  ...defaultValues,
                }}
                isModalMode={isModalMode}
                isLoading={isLoading}
                isEditMode={!isViewMode}
              />

              {children}
            </Box>
          </Box>
          {footer}
        </form>
      </FormProvider>
    </Box>
  );
};

export default RoleSetupForm;
